import React from 'react';
import { Control, Controller } from 'react-hook-form';
import { Permissions } from '@askporter/auth-provider';
import { OrgExportCreate, OrgExportCreateFieldsEnum } from '@askporter/client-grieg-lyric';
import { exportOrgsCheckboxFieldsPermissionMapping } from '../../../utils/exportCheckboxFieldPermissionMapping';
import { ExportFieldCheckbox } from '../../ExportFieldCheckbox';

interface ExportOrgsFieldsProps {
  /**
   * The translation function
   */
  t: (key: string, options?: Record<string, string | number>) => string;
  /**
   * The form control
   */
  control: Control<OrgExportCreate>;
  // TODO: Weird error(Passing OrgExportModalFormControlType from ../../../types causes a resolver error)
}

/**
 * Renders the checkboxes for the orgs export modal based on the user's role
 */
export const ExportOrgsFields: React.FC<ExportOrgsFieldsProps> = ({ t, control }) => {
  const nonEssentialFields = Object.values(OrgExportCreateFieldsEnum);

  return (
    <>
      <Permissions requiredRoles={exportOrgsCheckboxFieldsPermissionMapping.ORG_ESSENTIALS}>
        <ExportFieldCheckbox
          fieldId="ORG_ESSENTIALS"
          disabled={true}
          label={t('orgs:export_modal:org_essentials:checkbox:label')}
          subLabel={t('orgs:export_modal:org_essentials:checkbox:subLabel')}
          isChecked={true}
        />
      </Permissions>

      {nonEssentialFields.map((fieldId, index) => (
        <Permissions key={index} requiredRoles={exportOrgsCheckboxFieldsPermissionMapping[fieldId]}>
          <Controller
            name="fields"
            control={control}
            defaultValue={[]}
            render={({ field }) => (
              <ExportFieldCheckbox
                fieldId={fieldId}
                label={t(`orgs:export_modal:${fieldId.toLowerCase()}:checkbox:label`)}
                subLabel={t(`orgs:export_modal:${fieldId.toLowerCase()}:checkbox:subLabel`)}
                isChecked={field.value.includes(fieldId)}
                onChange={(checked) =>
                  field.onChange(checked ? [...field.value, fieldId] : field.value.filter((value) => value !== fieldId))
                }
                disabled={field.disabled}
              />
            )}
          />
        </Permissions>
      ))}
    </>
  );
};
